'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Validation } from './lib/Validation'
import { FormFile } from './lib/FormFile'
import { Accordion } from './lib/Accordion'
import { IndexScrollMask } from './lib/IndexScrollMask'
import { ContainerOver } from './lib/ContainerOver'
import { EndlessSlider } from './lib/EndlessSlider'
import { InterviewSlider } from './lib/InterviewSlider'
import { FadeSlider } from './lib/FadeSlider'
import { HeaderSize } from './lib/HeaderSize'
import { Loading } from './lib/Loading'
import { IntersectionSidebar } from './lib/IntersectionSidebar'
import { JobSlider } from './lib/JobSlider'
import { Agreement } from './lib/Agreement'
// new CookiePolicy('optout')

new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Validation()
new FormFile()
new Accordion()
new IndexScrollMask()
new ContainerOver()
new EndlessSlider()
new InterviewSlider()
new FadeSlider()
new HeaderSize()
new Loading()
new IntersectionSidebar('js-work-intersection', 'js-work-intersection-sidebar', 'js-work-intersection-section')
new IntersectionSidebar('js-interview-intersection', 'js-interview-intersection-sidebar', 'js-interview-intersection-section')
new IntersectionSidebar('js-recruitment-intersection', 'js-recruitment-intersection-sidebar', 'js-recruitment-intersection-section')
new JobSlider()
new Agreement()
